import { createBrowserRouter } from 'react-router-dom'

import { AppLayout, HomeLayout, SectionsLayout } from 'layouts'
import * as Page from 'pages'

const router = createBrowserRouter([
  {
    path: '/',
    Component: AppLayout,
    children: [
      {
        index: true,
        element: <Page.Welcome />,
      },
      {
        Component: HomeLayout,
        children: [
          {
            Component: SectionsLayout,
            children: [
              {
                path: '/home',
                element: <Page.Home />,
              },
            ],
          },
          {
            path: '/event/:id',
            element: <Page.Event />,
          },
        ],
      },
      {
        Component: SectionsLayout,
        children: [
          {
            path: '/profile',
            element: <Page.User />,
          },
          {
            path: '/premium',
            element: <Page.Premium />,
          },
          {
            path: '/payment',
            element: <Page.PaymentData />,
          },
          {
            path: '/chart',
            element: <Page.Chart />,
          },
        ],
      },
      {
        path: '/new-event',
        element: <Page.CreateEvent />,
      },

      {
        path: '/baby/edit',
        element: <Page.EditBaby />,
      },
      {
        path: '/baby/notification/edit',
        element: <Page.EditNotification />,
      },
    ],
  },
])

export default router
